export default __webpack_public_path__ + "static/media/gameI-intro1.49500dcd.png";